import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Header from "../../../layouts/Header";
import { FetchUserById } from "../../../redux/actions/action";

const Personalpage = () => {
  const userBankInfo = null;
  const dispatch = useDispatch();
  const history = useHistory();
  const userid = window.localStorage.getItem("userid");
  const [loading, setLoading] = useState(true);
  const [editProfile, setEditProfile] = useState(false);
  const userData = useSelector((state) => state.user.FetchUserById);
  const FetchCompanyDetails1 = useSelector(
    (state) => state.user.FetchCompanyDetails
  );
  const [FetchCompanyThemRes, setFetchCompanyThemRes] = useState([]);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [dob, setDob] = useState("");
  const [country, setCountry] = useState("");
  const [city, setCity] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [address, setAddress] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [teamId, setTeamId] = useState("");
  React.useEffect(() => {
    dispatch(FetchUserById(userid));
  }, []);
  const initialRender = React.useRef(true);
  React.useEffect(() => {
    if (!initialRender.current) {
      if (userData != null) {
        if (userData.status == true) {
          setFirstName(userData.data[0]?.firstname);
          setLastName(userData.data[0]?.lastname);
          setDob(userData.data[0]?.dateofbirth);
          // setPhone(userData.data[0]?.phoneNumber);
          setEmail(userData.data[0]?.email);
          // window.localStorage.setItem("userid", loginData.data[0]?.userid);
          // window.localStorage.setItem("roleid", loginData.data[1][0]?.roleid);
          // setMsgalert(loginData.message);
          // setTimeout(() => {
          //   history.push("/personalpage");
          //   window.location.reload();
          // }, 2000);
        } else {
          // setMsgalert(loginData.message);
          // setIncPass(true);
          // setAlert(true);
          // setError(true);
        }
      }
      if (FetchCompanyDetails1 != null) {
        if (FetchCompanyDetails1.status == true) {
          setFetchCompanyThemRes(FetchCompanyDetails1.data);
          // setCompenylLogo(FetchCompanyDetails1.data[0]?.companylogo)
        } else {
        }
      }
    } else {
      initialRender.current = false;
    }
  }, [userData]);

  return (
    <div
    //  style={{backgroundColor:`${FetchCompanyThemRes[0]?.backgroundimage}`}}
    >
      <div class="container-fluid">
        <div class="  px-xl-5 px-lg-5 px-md-0 px-sm-0  mb-5 headerspace ">
          <Header />
          {/* <div class="row my-5 px-xl-2 px-lg-1 px-md-0 px-sm-4 px-4">
            <hr class="hrline" />
          </div> */}

          <div class="row mt-5">
            <div
              onClick={() => setEditProfile(!editProfile)}
              className="row text-end editFunc"
            >
              {editProfile == false ? (
                <i class="bi bi-pen fs-4"></i>
              ) : (
                <i class="fa fa-times fs-4" aria-hidden="true"></i>
              )}
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 px-5 ">
              <div
                class="row poppinsfont fw-bold  fs-5 px-0 mt-2"
                style={{ color: `${FetchCompanyThemRes[0]?.textcolor}` }}
              >
                Personal information
              </div>
              <div
                class="row settinglabel px-0 mt-4"
                style={{ color: `${FetchCompanyThemRes[0]?.textcolor}` }}
              >
                Name
              </div>

              <div class="row poppinsfont px-0 mt-1 fs-5">
                {editProfile == true ? (
                  <input
                    className="w-75 mt-1 profileInput"
                    type="text"
                    value={firstName}
                    onChange={(e) => {
                      setFirstName(e.target.value);
                    }}
                  />
                ) : (
                  <p class="ps-0">{firstName}</p>
                )}
              </div>
              <div
                class="row settinglabel px-0 mt-2"
                style={{ color: `${FetchCompanyThemRes[0]?.textcolor}` }}
              >
                Surname
              </div>

              <div class="row poppinsfont px-0 mt-1 fs-5">
                {editProfile == true ? (
                  <input
                    className="w-75 mt-1 profileInput"
                    type="text"
                    value={lastName}
                    onChange={(e) => {
                      setLastName(e.target.value);
                    }}
                  />
                ) : (
                  <p class="ps-0">{lastName}</p>
                )}
              </div>

              <div
                class="row settinglabel px-0 mt-2"
                style={{ color: `${FetchCompanyThemRes[0]?.textcolor}` }}
              >
                Date of Birth
              </div>

              <div class="row poppinsfont px-0 mt-1 fs-5">
                {editProfile == true ? (
                  <input
                    className="w-75 mt-1 profileInput"
                    type="date"
                    value={dob}
                    onChange={(e) => {
                      setDob(e.target.value);
                    }}
                  />
                ) : (
                  <p class="ps-0">{dob}</p>
                )}
              </div>

              <div class="row settinglabel px-0 mt-2">Country</div>

              <div class="row poppinsfont px-0 mt-1 fs-5">
                {editProfile == true ? (
                  <input
                    className="w-75 mt-1 profileInput"
                    type="text"
                    value={country}
                    onChange={(e) => {
                      setCountry(e.target.value);
                    }}
                  />
                ) : (
                  <p class="ps-0">{country}</p>
                )}
              </div>
              <div class="row settinglabel px-0 mt-2">city</div>

              <div class="row poppinsfont px-0 mt-1 fs-5">
                {editProfile == true ? (
                  <input
                    className="w-75 mt-1 profileInput"
                    type="text"
                    value={city}
                    onChange={(e) => {
                      setCity(e.target.value);
                    }}
                  />
                ) : (
                  <p class="ps-0">{city}</p>
                )}
              </div>

              <div class="row settinglabel px-0 mt-2">Postal Code</div>

              <div class="row poppinsfont px-0 mt-1 fs-5">
                {editProfile == true ? (
                  <input
                    className="w-75 mt-1 profileInput"
                    type="text"
                    value={postalCode}
                    onChange={(e) => {
                      setPostalCode(e.target.value);
                    }}
                  />
                ) : (
                  <p class="ps-0">{postalCode}</p>
                )}
              </div>

              <div class="row settinglabel px-0 mt-2">Address</div>

              <div class="row poppinsfont px-0 mt-1 fs-5">
                {editProfile == true ? (
                  <input
                    className="w-75 mt-1 profileInput"
                    type="text"
                    value={address}
                    onChange={(e) => {
                      setAddress(e.target.value);
                    }}
                  />
                ) : (
                  <p class="ps-0">{address}</p>
                )}
              </div>
            </div>

            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 px-5 ">
              <div class="row settinglabel px-0 mt-5 pt-2">Phone number</div>

              <div class="row poppinsfont px-0 mt-1 fs-5">
                {editProfile == true ? (
                  <input
                    className="w-75 mt-1 profileInput"
                    type="number"
                    value={phone}
                    onChange={(e) => {
                      setPhone(e.target.value);
                    }}
                  />
                ) : (
                  <p class="ps-0">{phone}</p>
                )}
              </div>

              <div class="row settinglabel px-0 mt-2">Email</div>

              <div class="row poppinsfont px-0 mt-1 fs-5">
                {editProfile == true ? (
                  <input
                    disabled
                    className="w-75 mt-1 profileInput"
                    type="email"
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                    }}
                  />
                ) : (
                  <p class="ps-0">{email}</p>
                )}
              </div>
            </div>
          </div>
          {editProfile == true ? (
            <div className="row pt-4 pe-4 ps-2 d-flex justify-content-center justify-content-xl-end justify-content-lg-end justify-content-md-end ">
              <div className="col-9">
                {/* <button className='p-2 profileSubbtn' type='submit'>Submit</button> */}
              </div>
              <div className="col-3">
                <button
                  className="p-2 profileSubbtn"
                  type="submit"
                  //   onClick={(e) => {
                  //     handleUpdate(e);
                  //   }}
                >
                  Submit
                </button>
              </div>
            </div>
          ) : (
            ""
          )}
          <div class="row my-5 px-xl-0 px-lg-0 px-md-0 px-sm-4 px-4">
            <hr class="hrline" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Personalpage;
